
import * as React from "react";
import { CaseClient, ProfilesClient } from "@app/api2/api";
import { Container, Dropdown, DropdownItem, DropdownMenu, Menu, MenuItem, Tab } from "@/components/bp/bp-ui";
import { PageHeader } from "@common/PageHeader";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { BPSection } from "@common/BPSection";
import { HandlerRegistry } from "../CaseRun/RunTypes/HandlerRegistry";
import { ProfilesAll } from "./ProfilesAll";
import { useUser } from "../Contexts/UserContext";
import { BPContainer } from "@/components/bp/bpcontainer";

interface ProfilesProps {
    canCreateCase: boolean;
}

export const Profiles = (props: ProfilesProps) => {
    const me = useUser();

    const client = new ProfilesClient();
    const caseClient = new CaseClient();

    // const [labId] = useSessionItem('labId_sk');
    // const canSearch = labId != null && labId > 0;
    const searchTypes = ['dnamatch', 'familial_search'];
    return (
        <BPContainer>
            <PageHeader header={window.translation.common.samples}
                buttons={[{
                    label: 'Create',
                    to: buildUrl(AppRoutes.ProfilesMetadataCreate, {})
                }]}
                renderRight={() => {

                    return (
                        <>
                            {true && (
                                <>
                                    <MenuItem fitted>
                                        <Dropdown text={window.translation.common.search} button>
                                            <DropdownMenu>
                                                {searchTypes.map(rt => {
                                                    return (<DropdownItem key={rt} onClick={async () => {
                                                        if (me.user.hasSingleLab) {
                                                            let daily = await caseClient.createDaily(me.user.lab.id);
                                                            let url = buildUrl(AppRoutes.CaseRunCreate, {
                                                                labId: me.user.lab.id,
                                                                caseId: daily.caseId,
                                                                runType: rt
                                                            });
                                                            window.location.assign(url);
                                                        } else {
                                                            window.location.assign(buildUrl(AppRoutes.CaseRunCreateWithLabSelect, { runType: rt }));
                                                        }
                                                    }}>
                                                        {window.translation.runType[rt]}
                                                    </DropdownItem>)
                                                })}
                                            </DropdownMenu>
                                        </Dropdown>
                                    </MenuItem>
                                    <MenuItem fitted>
                                        <Dropdown text={window.translation.common.upload} button>
                                            <DropdownMenu>
                                                <DropdownItem as="a" href={buildUrl(AppRoutes.ProfilesEvidenceUpload, {})}>
                                                    {window.translation.common.evidence}
                                                </DropdownItem>
                                                <DropdownItem as="a" href={buildUrl(AppRoutes.ProfilesSampleUpload, {})}>
                                                    {window.translation.common.referenceProfile}
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </MenuItem>
                                </>
                            )}
                        </>
                    )
                }}
            />

            <BPSection header={window.translation.common.profiles}>
                <ProfilesAll />
            </BPSection>
            <BPSection header={window.translation.common.searches}>


                <Tab
                    menu={{ secondary: true, pointing: true }}
                    panes={
                        searchTypes.filter(x => HandlerRegistry.hasOwnRunList(x)).map(rtype => {
                            return { menuItem: window.translation.runType[rtype], render: () => HandlerRegistry.renderRunList(rtype, { canCreateEvidence: true, caseId: null, labId: null }) }
                        })
                    } />

            </BPSection>
        </BPContainer>
    );
};